export default {
    'zh-tw': {
        flag: 'taiwan',
        shopManagement: '店舖管理者',
        estimatedPaymentAmount: '預付款額度',
        common: {
            search: '搜尋',
        },
        footer: {
            address: 'Ergosleep Building 3F, Nonhyeon-ro 721 Gangnam-gu, Seoul, Korea',
            customerService: 'Customer Service 822-1577-0564',
            companyNameKorean: 'B1SOFT CO.,LTD',
            companyCeoName: 'CEO: Choi Seok Woong',
            businessLicenseNumberText: 'Business License Number',
            businessLicenseNumber: '816-87-01138',
            companyNameEnglish: 'B1SOFT., LTD B1SOFT',
        },
        currency: {
            kr: {
                text: 'KRW',
                symbol: '₩',
            },
            us: {
                text: 'USD',
                symbol: '$',
            },
        },
        grade: {
            Rookie: '新手',
            Beginner: '初學',
            Amateur: '業餘',
            SemiPro: '半職業',
            Pro: '職業',
            TourPro: '頂尖職業',
            Challenger: '挑戰者',
        },
        gender: {
            man: '男性',
            woman: '女性',
            unLimit: '不限',
        },
        menu: {
            shopInfoManagement: '店舖管理資訊',
            gameRoundOptionOptionManagement: '下場選項管理',
            drivingRangeOptionOptionManagement: '練習場選項管理',
            realtimeControlOptionManagement: '即時選項管理',
            agreement: '條款',
            signOut: '登出',
        },
        signIn: {
            id: '帳號',
            password: '密碼',
            forgotId: '忘記帳號',
            forgotPassword: '忘記密碼',
            rememberMe: '維持登入狀態',
            buttonSignIn: '登入',
            cookie: 'Cookie 刪除',
            cookieMessage: 'Cookie 已刪除。 ',

            fail: '登入失敗。請再試一次。',
        },
        notification: {
            title: '通知',
            no: '編號',
            roomName: '球道名稱',
            callTime: '稱呼時間',
            message: '訊息',
            confirm: '確認',
            noNotificationMSG: '沒有呼叫通知訊息。',

            billing_automatic_payment_failed: '[K-Golf 自動付款失敗通知] 您的 K-Golf 自動付款失敗。${payment_date} 之後，您將無法使用練習場以外的內容。請聯絡客服以處理付款問題或獲取更多資訊。[客服中心] ${customer_center_number}',
            billing_automatic_payment_guide: '[K-Golf 自動付款提醒] 您的 K-Golf 自動付款預定於 ${payment_date} 進行。請確保您的帳戶狀態正常。如果付款未如期完成，${payment_date} 之後，您將無法使用練習場以外的內容。[客服中心] ${customer_center_number}',
            billing_automatic_payment_success: '[K-Golf 付款成功通知] 您的 K-Golf 自動付款已成功完成。',
            billing_content_restrictions_notice: '[K-Golf 使用限制通知] 因未在付款截止日期前完成付款，${payment_date} 之後，您將無法使用練習場以外的內容。如需支付未付款項或獲取更多資訊，請聯絡客服中心。[客服中心] ${customer_center_number}',
            billing_manual_payment_guide: '[K-Golf 一般付款期間通知] 您的付款期間為 ${start_date} 至 ${end_date}（共 ${diff_day} 天）。如果在此期間未完成付款，${end_date} 之後，您將無法使用練習場以外的內容。[客服中心] ${customer_center_number}',

            game_client_additional_access_game_round_approval_failed: '無法批准 ${client_name} 的額外回合使用請求。',
            game_client_additional_access_game_round_request: '${client_name} 已請求額外回合使用。',
            game_client_additional_access_game_round_request_reject: '${client_name} 的額外回合使用請求已被拒絕。',

            game_client_cancel_shot_failed: '無法取消 ${client_name} 的最後一桿。',
            game_client_cancel_shot_failed_2: '玩家已用完所有可用的取消次數。',
            game_client_cancel_shot_failed_3: '遊戲進行中，無法取消。',
            game_client_cancel_shot_failed_4: '無可取消的擊球。',
            game_client_cancel_shot_success: '已成功取消 ${client_name} 的最後一桿。',

            game_client_extended_wait_success: '${client_name} 已設為等待狀態。',

            game_client_force_disconnection_failed: '無法強制斷開 ${client_name} 的連線。',
            game_client_force_disconnection_success: '${client_name} 的連線已成功斷開。',

            game_client_guest_login_failed: '無法登錄 ${client_name} 的訪客帳戶。',
            game_client_guest_login_success: '${client_name} 的訪客登錄成功。',

            game_client_limit_change_failed: '無法發送 ${client_name} 的控制選項更改。',
            game_client_limit_change_success: '${client_name} 的控制選項已更新。',

            game_client_lock_failed: '無法鎖定 ${client_name}。',
            game_client_lock_success: '${client_name} 已被鎖定。',

            game_client_player_count_change_failed: '無法更改 ${client_name} 的玩家人數。',
            game_client_player_count_change_request_reject: '${client_name} 的玩家人數更改請求已被拒絕。',
            game_client_player_count_change_success: '${client_name} 的玩家人數已從 ${n} 人更改為 ${player_count} 人。',

            game_client_reset_mulligan_failed: '無法重置 ${client_name} 的暫緩擊球次數。',
            game_client_reset_mulligan_success: '${client_name} 的暫緩擊球次數已重置。',

            game_client_shop_manager_call_request: '${client_name} 已呼叫店長支援。',

            game_client_time_extension_failed: '無法延長 ${client_name} 的使用時間。',
            game_client_time_extension_request: '${client_name} 已請求延長使用時間。',
            game_client_time_extension_request_reject: '${client_name} 的使用時間延長請求已被拒絕。',
            game_client_time_extension_success_1: '${client_name} 的使用時間已延長 ${add_time} 分鐘。',

            game_client_unlock_failed: '無法解鎖 ${client_name}。',
            game_client_unlock_success: '${client_name} 已解鎖。',

            game_client_user_login_failed: '無法登錄 ${client_name} 的使用者帳戶。',
            game_client_user_login_success: '${client_name} 的使用者登錄成功。',

            kms_notice: '${title}',

            quit_game_client_failed: '無法處理 ${client_name} 的退出請求。',
            quit_game_client_success: '${client_name} 的退出請求已成功完成。',

            run_game_client_failed: '無法啟動 ${client_name} 的遊戲。',
            run_game_client_success: '${client_name} 的遊戲已成功啟動。'
        },
        dashboard: {
            content: 'Dashboard',
        },
        gameHistory: {
            searchPeriod: '搜尋期間',
            userNickname: '會員暱稱',
            userNicknamePlaceholder: '請輸入暱稱',
            search: '搜尋',
            gameType: '遊戲類型',
            shopClient: '打位',
            all: '所有',
            gameHistoryStatistics: '遊戲歷史統計',
            gameHistoryStatisticsNoticeText: '搜尋結果的統計。 ',
            gameMode: '遊戲類型',
            normalGame: '一般遊戲',
            drivingRange: '練習場',
            swingDiagnosis: '揮桿診斷',
            userType: '會員分類',
            user: '會員',
            guest: '嘉賓',
            gender: '性別',
            male: '男',
            female: '女',
            times: '時間',
            gameRoundList: '遊戲回合列表',
            gameNumbers: '遊戲編號',
            clientName: '球道名稱',
            numberPlayers: '選手數',
            numberHolesCompleted: '已完成洞數',
            startDate: '開始時間',
            endDate: '結束時間',
            more: '看更多',
            close: '折疊',
            download: 'Download',
            alert: {
                message1: '必須至少選擇一個蝙蝠座位',
                message2: '必須至少選擇一種遊戲類型',
                message3: '期限最多只能選3個月。 ',
                message4: '根據搜尋資料量可能會延遲。 \\n確定要進行嗎？ ',
                message5: 'No data',
            },
        },
        clientStatus: {
            sendMessage: '傳送訊息',
            statusInfo: '狀態訊息',
            proceeding: '處理中',
            endUse: '遊戲結束',
            blind: '已鎖定',
            lobby: '大廳',
            clientOff: '程式關閉',
            course: '球場',
            playerCount: '選手數',
            remainingTime: '剩餘時間',
            start: '開始',
            paymentType: '付款類別',
            usageModeSetting: '設定模式',
            gameType: '遊戲類型',
            usageTimeSetting: '使用時間設定',
            holeType: '球洞類別',
            drivingRangeTime: '練習場使用時間',
            noLimit: '無限',
            stroke: '擊球',
            drivingRange: '練習場',
            minutes: '分鐘',
            lessThanMinute: '少於一分鐘',
            paymentProgress: '後付款正在進行中',
            peopleCount: '人員',
            noDrivingRange: '無',
            status: '狀態',
            usageTime: '使用時間',
            usageCourse: '利用球場',
            usagePeopleCount: '玩家人數',
            addGuest: '新增遊客',
            extendedTime: '延長的時間',
            scorecard: '計分卡',
            changeSetting: '變更設定',
            resetMulligan: '重置摸桿',
            cancelShot: '取消拍攝',
            bilnd: '已鎖定',
            currentHole: '目前洞',
            sound : '通知聲音',
            clientType : '擊球時分類',
            popup: {
                close: 'close',
                addGuest: {
                    addGuest: '新增遊客',
                    guestNicknamePlaceholder: '輸入遊客名稱',
                    cancel: '取消',
                },
                shotCancel: {
                    confirmMessage: '將取消「${clientName}」打擊區的最後一桿。',
                    shotCancel: '消除',
                    cancel: '查看',
                },
                sendMessage: {
                    sendMessage: '傳送訊息',
                    all: '所有',
                    cancel: '取消',
                    messagePlaceholder: '請輸入要傳送的訊息',
                },
                extendedTime: {
                    extendedTime: '延長的時間',
                    minutes: '分鐘',
                    addServiceTime: '新增服務時間',
                    cancel: '取消',
                },
                changeSetting: {
                    changeSetting: '變更設定',
                    cancel: '取消',
                },
            },
            alert: {
                message1: '選擇付款方式',
                message2: '請選擇使用時間設定',
                message3: '請選擇使用模式設定',
                message4: '請選擇遊戲類型',
                message5: '請選擇孔類型',
                message6: '請選擇玩家人數',
                message7: '請選擇練習時間',
                message8: '請確認要鎖定畫面嗎？ ',
                message9: '請稍後再試',
                message10: '請確認初始化目前進行中遊戲的摸桿嗎？ ',
                message11: '因沒有下場ID資訊, 無法申請初始化',
                message12: '您想更改打位控制設定嗎？ ',
                message13: '您想更改下場設定嗎？ ',
                message14: '請選擇傳送訊息的打位',
                message15: '請輸入訊息',
                message16: '該打位是後付費，所以不能延長時間。 ',
                message17: '請重新選擇需要延長的時間',
                message18: '請輸入遊客暱稱',
                message19: '因可登入的人員數不足，無法申請遊客登入',
                message20: '由於沒有遊戲回合 ID 訊息，因此您無法要求取消擊球。',

                message1000: '下場設定更改功能準備中',
            },
        },
        billing: {
            tossPay: {
                addressTitle: '收貨地址',
                clearAddressButton: '清除地址',
                clearAddressTooltip: '保留收件人/電話，只清除地址',
                recipientPlaceholder: '收件人',
                phonePlaceholderKrw: '聯絡電話（例：010-1234-5678）',
                phonePlaceholderIntl: '聯絡電話（可含國碼）',
                postcode: '郵遞區號',
                searchAddressButton: '查詢地址',
                address1Krw: '基本地址',
                address2Krw: '詳細地址（棟/房號等）',
                address1Intl: '地址第一行',
                searchHint: '搜尋…',
                address2Intl: '地址第二行（公寓、單元等）',
                country: '國家',
                city: '城市',
                state: '州/省/地區',
                postalIntl: '郵遞區號 / ZIP',
                saveNoteKrw: '※ 結帳時會一併保存收貨地址。',
                saveNoteIntl: '※ 您的收貨地址將隨付款一併保存。',
                fedexTitle: 'FedEx 帳號',
                fedexPlaceholder: '請輸入 FedEx 帳號',
                fedexNote: '※ 用於到付（Collect）寄送。',
                // ▼ 新增
                fedexHelpTitle: '尚未擁有 FedEx 帳號？',
                fedexHelpDesc: '請透過以下連結建立。',
                fedexGlobalLink: '建立 FedEx 帳號（全球）',
                fedexUSLink: '建立 FedEx 帳號（美國）',
                fedexGuideLink: '如何建立 FedEx 帳號？（FAQ）',
                paymentMethodsTitle: '付款方式',
                agreeRequired: '需同意付款服務條款與隱私權政策。',
                enterShipping: '請輸入收貨地址。',
                enterFedex: '請輸入 FedEx 帳號。',
                payNow: '立即付款',
                cardLabel: '信用卡',
                paypalLabel: 'PayPal',
                alipayLabel: '支付寶',
            }
            ,
            paymentInfo: {
                ownerDefaultInfo: '店主預設訊息',
                shopName: '店名',
                shopOwnerName: '店主名稱',
                shopAddress: '店家地址',
                shopAddressChangeNoticeText: '如需更改您的店家地址，請聯絡客服中心',
                receiveBillInfoChange: '更改帳單資訊',
                receiveBillInfoChangeNoticeText: '接收每月的費用清單',
                shopOwnerMobilePhone: '店主聯絡資訊',
                editButton: '編輯',
                mobileBill: '行動端訊息',
                mobileBillNoticeText: '每月將使用費用明細表發送到店主的手機或郵箱。 ',
                sendButton: '發送',
                shipsFirstDayEveryMonth: '每個月1號郵寄',
                mobileBillNoAuth: '如果您不執行行動資訊驗證，您將無法接收付款對帳單。 ',
                shopOwnerEmail: '店主信箱地址',
                authenticateButton: '驗證按鈕',
                emailBill: '郵箱聲明',
                emailBillNoticeText: '月結單將發送到註冊店主的電子郵件',
                emailBillNoAuth: '如果您不執行行動資訊驗證，您將無法接收付款對帳單。 ',
            },
            recurringPayment: {
                noRecurringPaumentServiceNoticeText1: '沒有登記定期付款服務。 ',
                noRecurringPaumentServiceNoticeText2: '只有註冊了定期支付服務，才能查看定期支付管理。 ',
                agreementToUseRecurringPaymentService: '同意使用定期支付服務',
                guide: '定期支付服務登記',
                whatIsRecurringPaymentService: '什麼是定期付款服務？ ',
                recurringPaymentServiceDescription:
                    '這是每月在總公司 K-Golf 指定的付款日期自動提取付款金額的服務。 <br/>如果您使用常規付款服務，最大付款金額為 2。 有 %<br/> 的費率折扣',
                agreeTermsConditionsRecurringPayment: '同意定期付款的條款和條件',
                allAgreement: '完整的協議',
                required: '必要的',
                termsOfRecurringPaymentService: '定期結算服務條款',
                personalInformationProvidedThirdParties: '同意向第三者提供個人資料',
                entrustingHandlingOfPersonalInformation: '同意委託處理個人資料',
                useAgreementButtonText: '定期結算服務條款',
                useAgreementNoticeText: '使用協議通知文本',
                recurringPaymentService: '定期付款服務條款',
                status: '狀態',
                statusApplyingText: '應用現狀',
                statusUseText: '在使用',
                serviceStartDate: '服務開始日期',
                automaticPaymentDueDate: '自動付款截止日期',
                discountRate: '折扣',
                recurringPaymentServiceCancel: '取消定期付款服務',
                bankAccountRegistrationAndManagement: '銀行帳戶的註冊和管理',
                bankAccount: '銀行帳戶',
                bankAccountNumber: '銀行帳號',
                bankAccountName: '銀行帳戶名稱',
                management: '管理',
                addBankAccount: '新增銀行帳戶',
                deleteBankAccount: '刪除銀行帳戶',
                noBankAccountNoticeText: '沒有註冊帳號。 <br/>點選右側的帳號註冊按鈕進行帳號註冊',
                creditCardRegistrationAndManagement: '信用卡登記與管理',
                creditCard: '信用卡',
                creditCardNumber: '信用卡號碼',
                noCreditCardNoticeText: '沒有已註冊的卡片。 <br/>請點選右側的卡片註冊按鈕進行卡片註冊',
                addCreditCard: '卡片註冊',
                deleteCreditCard: '刪除卡片',
                recurringPaymentNoticeText: '如果在自動支付服務中同時註冊了<strong style={{color:"#333333"}}>帳戶</strong>和卡 >',
            },
            paymentProgress: {
                text1: '付款資訊正在驗證',
                text2: '請稍等',
            },
            paymentComplete: {
                text1: '支付成功',
                text2: '（使用虛擬帳戶付款時，需待入帳確認後方可使用服務）',
                buttonText: '完成',
            },
            paymentFail: {
                text1: '支付失敗',
                text2: '',
                buttonText: '關閉',
            },
            paymentCancel: {
                text1: '取消付款',
                text2: '',
                buttonText: '關閉',
            },
            payment: {
                generalPayment: '一般費用支付',
                prepayment: '預期金額預付',
                paymentUnpaidCharges: '支付未支付的費用',

                chargesText: '支付金額為<spanclass="price">|charges|</span><spanstyle="font-size"',
                checkPaymentHistory: '請檢查付款詳情',
                billingMonth: '支付每月',
                amountBePaid: '需支付金額',
                details: '詳情',
                choosePaymentMethod: '選擇付款方式',
                realTimeAccountTransfer: '銀行轉帳',
                creditCardPayment: '信用卡支付',

                tab1: {
                    text1: '目前沒有需要支付的一般費用',
                    text2: '沒有需要支付的金額',
                    text3: '一般費用支付週期',
                    text4: '一般費用只能從每月1日起支付, 直到本公司指定的付款日期為止。 ',
                    text5: '支付截止日期',
                    text6: '一般費用支付週期',
                    text7: '每個月',
                    text8: '日期',
                },
                tab2: {
                    text1: '目前無法提前支付',
                    text2: '沒有需要支付的金額',
                    text3: '預付週期',
                    text4: '預付只能從每月1日起支付, 直到本公司指定的付款日期為止。 ',
                    text5: '支付截止日期',
                    text6: '一般費用支付週期',
                    text7: '每個月',
                    text8: '日期',
                },
                tab3: {
                    text1: '沒有未支付金額',
                    text2: '您可以在本公司指定的付款日期後支付未付金額。 ',
                    text3: '付款日期',
                    text4: '每個月',
                    text5: '日期',
                    text6: '預付可用',
                    text7: '預付只能從每月1日起支付, 直到本公司指定的付款日期為止。 ',
                    text8: '支付截止日期',
                    text9: '預付週期',
                },
            },
            bills: {
                monthPaymentAmount: '|month|付款金額',
                usagePeriod: '使用週期',
                clientName: '客戶姓名',
                usageAmount: '使用數量',
                discountAmount: '折扣數',
                paymentAmount: '支付數',
                contentPlan: '內容計畫',
                coursePlan: '球場計畫',
                minutes: '分鐘',
                course: '球場',
                totalCharges: '總金額',
                count: '總數',
                coutseUnlimit: '無限',
                vat: '增值稅',
                currentMonthTotalCharges: '月度總金額',
                totalAmount: '總數額',
            },
            paymentHistory: {
                text1: '您只能搜尋過去12個月的記錄。 ',
                billMonth: '發行月費',
                charges: '金額',
                paymentStatus: '付款狀態',
                paymentSuccess: '支付成功',
                unpayment: '不付款',
            },
            itemPaymentHistory: {
                info01: '為了確認您的收貨，請檢查您購買商品時輸入的電子郵件地址。 ',
                info02: '如需申請退款，請聯絡客服。 ',
                date: '購買日期',
                orderNumber: '訂單號碼',
                purchaseItem: '購買物品',
                charges: '付款金額',
                paymentMethod: '付款方式',
                materialCode: '物料代碼',
                quantity:     '數量',
                paymentMethods: {
                    CA:              '信用卡',
                    AccountTransfer: '銀行轉帳',
                    PZ:              'PZ支付',
                    EASYPAY:         '易支付',
                },
                statuses: {
                    0: '商品準備中',
                    1: '已發貨',
                    2: '已送達',
                    3: '退款',
                },
            },
        },
        customerService: {
            notice: {
                postType: '類別',
                searchPlaceholder: '搜尋字元',
                postTitle: '標題',
                registrationDate: '註冊日期',
                attachments: '附件',
                moveListButtonText: '列表',
                postTypeCode: {
                    notice: 'Notice',
                    update: 'Update',
                    event: 'Event',
                },
            },
            qna: {
                test: 'test',
            },
        },
        edit: {
            shopInfoSetting: {
                clientTypeAlert: '必須檢查至少一種擊球類型。 ',

                shopInfo: '商舖資訊',
                shopName: '店名',
                shopPhoneNumber: '商店電話',
                shopAddress: '店家地址',
                shopOwnerName: '店主名稱',
                shopOwnerMobilePhone: '店主電話',

                shopSalesInfo: '商店銷售資訊',
                operatingTime: '營業時間',
                operatingTimePlaceholder: '例)\n平日 AM 08:00 ~ PM:12:00 \n週末/公休日 AM 06:00 ~ PM 12:00',
                screen: '螢幕',
                practiceRange: '練習本',
                lesson: '輔導',
                convenientFacilities: '便利設施',
                swingPlate: '擺動板',
                leftHanded: '兩打',
                parking: '停車場',
                equipmentStorage: '設備保管',
                proLesson: '職業輔導',
                fee: '使用費',
                feePlaceholder: '例）\n詳細價格請聯絡商店。 ',
                storeView: '商店檢視',
                parkingNotice: '停車資訊',
                parkingPlaceholder: '例）\n免費停車（使用大樓停車場）',
                storeIntroduce: '賣場介紹',
                storeIntroducePlaceholder: '例如）\n會努力讓所有人都能舒適地享受高爾夫。 \n一直感謝您的光臨。 ',
                clientList: '打位清單',
                clientName: '客戶姓名',
                clientOrder: '打位訂單',
                clientInfo: '打位資料',
                clientType: '打位類別',
                cancel: '取消',
                saveChanges: '儲存變更',
            },
            shopGameRoundOptionSetting: {
                title: '回合選項管理',
                concede: '認輸',
                holecupPosition: '球杯位置',
                mulliganCount: '摸桿數',
                swingPlate: '動感平台',
                distanceUnit: '距離單位',
                greenPosition: '果嶺位置',
                greenSpeed: '果嶺速度',
                windStrength: '風力',
                puttingLine: '推桿線路',
                bestVideo: '最佳重播',
                continuePutting: '繼續推桿',
                caddyVoice: '球童聲音',
                noPuttMode: '跳過推桿',
                obTeeAndHazardTee: '出界發球檯和落水發球檯',
                on: '開啟',
                off: '關閉',
                saveChanges: '儲存變更',
                shotInfoLocation: '高爾夫揮桿情報',
                side: '側面',
                bottom: '下端',
                greenHardness: '果嶺硬度',
                guideDistance: '目標距離',
                maxScoreFactor: '每孔最大行程數',
            },
            shopDrivingRangeOptionSetting: {
                title: '練習場選項管理',
                course: '球場',
                drivingRange1: 'KGOLF',
                drivingRange2: '張家界',
                drivingRange3: '聖淘沙',
                drivingRange4: '隱藏城堡',
                drivingRange5: 'KGOLF2',
                difficulty: '難易度',
                teeHeight: '發球檯高度',
                windStrength: '風速',
                distanceUnit: '距離單位',
                swingPlate: '動感平台',
                ballTrajectory: '球軌跡',
                fixedCamera: '固定相機',
                swingVideo: '揮桿影像',
                on: '開',
                off: '關閉',
                saveChanges: '儲存變更',
            },
            shopClientRealTimeControlOptionSetting: {
                title: '標題',
                paymentType: '支付類別',
                usageTimeSetting: '使用時間設定',
                usageModeSetting: '設定模式',
                noLimit: '無限',
                stroke: '擊球',
                drivingRange: '練習場',
                usageContentSetting: '內容設定',
                availablePlayerCountSetting: '玩家數量設定',
                holeType: '球洞類別',
                drivingRangeTime: '練習場使用時間',
                saveChanges: '儲存變更',
                peopleUnit: '人員',
                none: '無',
                minutes: '分鐘',
            },
            accountInfoSetting: {
                accountInfo: '帳戶資訊',
                name: '名稱',
                id: 'ID',
                password: '密碼',
                changePassword: '更改密碼',
                newPasswordPlaceholder: '請輸入新密碼。',
                cancel: '取消',
                submit: '更改',
                validation: '密碼可設定為4至12個字符，須包括數字、小寫英文字母、大寫英文字母。',
                successful: '帳戶密碼已更改。',
                fail: '密碼更改失敗。',
            },
            clientInfoSetting: {
                clientInfo: '更改客戶端密碼',
                password: '密碼',
                changePassword: '更改密碼',
                newPasswordPlaceholder: '請輸入新密碼（4位數字）。',
                cancel: '取消',
                submit: '更改',
                validation: '密碼只能設定為4位數字。',
                successful: '所有商店顧客的密碼已更改。',
                fail: '密碼更改失敗。',
            },
        },
        scorecard: {
            title: '計分卡',
            gameNumbers: '比賽編號',
            gameType: '遊戲類型',
            courseName: '球場名稱',
            gameHoleType: '球洞類型',
            shopName: '店名',
            shopClientName: '球道名稱',
            startTime: '開始時間',
            endTime: '結束時間',
            concede: '認輸',
            holeCupPosition: '球杯位置',
            mulligan: '摸桿',
            greenPosition: '果嶺位置',
            greenSpeed: '果嶺速度',
            swingPlate: '動感平台',
            windStrength: '風力',
            distanceUnit: '距離單位',
            puttingLine: '推桿線路',
            bestVideo: '最佳重播',
            caddyVoice: '球童聲音',
            whetherUseObTeeAndHazardTee: '出界發球和落水發球',
            use: '使用',
            unused: '未使用的',
            stroke: '擊球',
            newPerio: '新貝利亞計分',
            ranking: '排名',
            team: '隊伍',
            nickname: '暱稱',
            handicap: '差點',
            close: '關閉',
            alertText1: '遊戲進行中',
            grade: '等級',
            greenHardness: '果嶺硬度',
            guideDistance: '目標距離',
            maxScoreFactor: '每孔最大行程數',
            on: '開啟',
            off: '關閉',
        },
        alert: {
            comingSoon: '敬請期待',
            unusualApproach: '這是一個不尋常的策略',
            deletePaymentMethodSuccess: '付款方式已成功刪除',
            deletePaymentMethodFail: '付款方式刪除失敗',
            shopRecurringPaymentCancelSuccess: '已完成取消訂閱付款',
            shopRecurringPaymentCancelFail: '取消訂閱付款失敗',
        },
        popup: {
            title: {
                sendMessage: '傳送訊息',
                scorecard: '計分卡',
                addGuest: '新增遊客',
                shotCancel: '射擊取消',
                extendedTime: '延長時間',
                changeSetting: '設定更改',
                courseSelection: '球場設定',
                rankingCriteriaGameRoundCount: '按比賽記錄多的順序指的是？ ',
                rankingCriteriaBackCount: '後半場計分方式指的是？ ',
                shopTournamentOpenConfirm: '比賽開設確認',
                shopTournamentModifyConfirm: '比賽修改確認',

                deleteTournamentConfirm: '預訂比賽刪除說明',
                earlyEndTournamentConfirm: '比賽提前結束說明',
                resetAwardsConfirm: '名單初始化說明',
                awardRecipientsSelectionConfirm: '授獎者選定確認',
                tournamentAwardAnnouncementConfirm: '授獎者發布確認',
                contentsItemPayment: '內容使用指南',
                callNotification: '稱呼通知',
            },
            button: {
                close: 'Close',
                cancel: '取消',
                confirm: '確認',
                announcement: '公佈。 ',
            },
        },
        agreement: {
            terms: '經營者使用條約',
            privacy: '個人資訊處理條款',
            refund: '退款規定',
            termsText:
                '本協議定義了作為高爾夫模擬器系統開發商兼製造商的K-Golf與透過K-Golf高爾夫模擬器系統經營營利性事業的業主（店主）之間有關系統使用的條款如下：\n\n' +
                '第1條（目的）\n' +
                '本條款（以下簡稱「本條款」）旨在規範使用者使用株式會社K-Golf（以下簡稱「公司」）所提供之服務（高爾夫模擬服務）、網際網路相關服務、網頁與行動服務時，公司與業主之間的權利、義務及責任事項，以及其他必要事項。\n\n' +
                '第2條（術語定義）\n' +
                '1.「業主」指安裝公司批准提供服務之K-Golf產品，並以營利為目的經營門市之營業負責人。\n' +
                '2.「K-Golf門市」（以下簡稱「營業場所」）指業主購買K-Golf產品，並獲得公司批准提供服務的K-Golf產品安裝場所。\n' +
                '3.「K-Golf產品」指由K-Golf開發與生產的高爾夫模擬系統。\n' +
                '4.「使用者顧客」指造訪營業場所，使用K-Golf產品並依據營業場所的收費政策支付使用費的顧客。\n' +
                '5.「計費」指使用公司開發的K-Golf產品軟體進行遊戲或付費內容時所產生的使用費徵收行為。\n' +
                '6.「K-Golf線上服務」指使用者顧客在營業場所使用K-Golf產品的所有服務（如線上高爾夫球場使用、使用者遊戲紀錄、活動參與等）。\n' +
                '7.「K-Golf線上服務使用費」指使用者顧客為使用「K-Golf線上高爾夫球場服務」而需支付的費用，按使用線上球場的形式進行收費。\n' +
                '8.「門市管理者」指公司提供給業主，用於線上管理K-Golf產品的電腦程式。\n\n' +
                '第3條（遊戲計費制度的運作）\n' +
                '1.計費方式如下：\n' +
                '  1) K-Golf線上高爾夫球場服務之球場使用費按每場遊戲向業主計費。\n' +
                '  2) 在球場模式中，每個球洞以100韓元為計費單位，共18洞。\n' +
                '  3) 若因使用者顧客因素或門市營運中斷遊戲，則依據已使用球洞數計費。\n' +
                '2.依照所選商品計費如下：\n' +
                '  1) 練習場C商品：僅可使用20個9洞球場，免收費。\n' +
                '  2) 組合型A・練習場B商品：可使用所有內容，球場使用時按洞數及人數收費。\n' +
                '3.付款方式如下：\n' +
                '  1) 原則上採用後付自動扣款方式，亦可選擇預付或逾期付款方式。\n' +
                '  2) 業主必須一次性支付每月應付總金額，無法部分支付。\n' +
                '  3) 後付自動扣款：於指定付款日自動結算上月（1日至月底）使用費（上午／下午各1次）。\n' +
                '  4) 預付：於指定付款日前2日以轉帳或信用卡付款。\n' +
                '  5) 逾期付款：逾期後由業主自行支付。\n\n' +
                '第4條（付款方式・欠款處理・商品變更）\n' +
                '1.付款方式包括轉帳與信用卡付款。\n' +
                '2.欠款處理如下：\n' +
                '  1) 超過付款日未支付者，立即停止服務。\n' +
                '  2) 自欠款日每日計收延遲利息（0.n%）。\n' +
                '  3) 完成欠款支付後恢復服務。\n' +
                '3.商品變更於每月1日生效。\n\n' +
                '第5條（條款外規範及與相關法律之關係）\n' +
                '1.未記載事項依相關法律與慣例處理。\n' +
                '2.電子商務法等消費者保護相關法律優先適用。\n' +
                '3.如有個別條款，則優先適用該條款。\n\n' +
                '第6條（免責條款）\n' +
                '1.因天災、戰爭、電信業者服務中斷等不可抗力所造成的損失，公司不承擔責任。\n' +
                '2.因設備維修、替換等造成的損失，公司不承擔責任。\n' +
                '3.因業主電腦錯誤、不實資訊填寫所造成的損失，公司不承擔責任。\n' +
                '4.未達預期收益或資料使用造成的損失，公司不承擔責任。\n' +
                '5.公司無義務事前審查使用者發佈的內容。\n' +
                '6.除違反隱私權政策的情況外，對免費服務不承擔任何責任。\n\n' +
                '第7條（契約解除等）\n' +
                '1.合意解除或轉讓時，須事前通知並清算欠款後，公司收回服務。\n' +
                '2.延遲支付時，按法定利率計收延遲利息。\n' +
                '3.部分使用的情況下，公司可要求相關金額與費用。\n\n' +
                '第8條（爭議解決）\n' +
                '1.設有專責的顧客申訴處理部門。\n' +
                '2.優先處理不滿與申訴，若有延誤將通知原因與預計時程。\n\n' +
                '第9條（準據法與管轄法院）\n' +
                '1.以大韓民國法律為準據法。\n' +
                '2.依據民事訴訟法向具有管轄權之法院提起訴訟。',

            privacyText:
                '第1條 總則\n' +
                '株式會社K高爾夫（以下簡稱「公司」）珍視使用者於使用本公司提供的店鋪管理服務（https://kms.thekgolf.com）時所提供的所有個人資料。公司遵守相關法令（通信秘密保護法、資訊通信網路法等），並透過個人資料保護政策清楚說明資料的蒐集與使用方式。政策可因法令與公司內部政策之變更而修訂。\n\n' +
                '第2條 個人資料的蒐集項目、方法及使用目的\n' +
                'a) 蒐集項目\n' +
                '  1）會員註冊·服務提供：姓名、ID、手機、地址、電子郵件（退會時刪除）\n' +
                '  2）帳戶支付：銀行名稱、帳號、戶名（保存5年）\n' +
                '  3）虛擬帳戶：銀行名稱、匯款人姓名（保存5年）\n' +
                '  4）信用卡支付：發卡行、卡號、有效期限（保存5年）\n' +
                '  5）交易資訊：IP、Cookie、連線記錄、使用記錄（退會時刪除）\n' +
                '  6）活動·配送：姓名、地址、電話（達成目的後銷毀）\n' +
                '  7）宣傳品：姓名、地址、電話（達成目的後銷毀）\n\n' +
                'b) 使用目的\n' +
                '  1）履行合約與費用結算\n' +
                '  2）會員管理、身份確認、防止不良使用、處理申訴\n' +
                '  3）開發新服務、行銷、統計、廣告\n' +
                '  4）服務異常時個別通知\n\n' +
                'c) 保留期間\n' +
                '  - 於服務使用期間內保留，退會或刪除請求時銷毀\n' +
                '  - 活動目的達成後立即銷毀\n' +
                '  - 不良會員紀錄自解約日起保存1年\n\n' +
                'd) 蒐集方法\n' +
                '  - 透過網站、書面、傳真、電話、公告欄、電子郵件、活動、Cookie·紀錄蒐集工具\n\n' +
                '第3條 個人資料的銷毀程序與方法\n' +
                'a) 銷毀程序：目的達成後，依內部政策與法令保存一定期間後銷毀\n' +
                'b) 銷毀方法：紙本文件以碎紙或焚燒方式處理，電子檔案以無法回復之方式刪除\n\n' +
                '第4條 個人資料的共享與提供\n' +
                '原則上未經事前同意不得對外提供，但以下情況例外：\n' +
                '  - 使用者已同意之情形\n' +
                '  - 費用結算、違反服務、依法機關要求等情形\n\n' +
                '第5條 處理委託\n' +
                '為提升服務品質，公司可將部分業務委託專業機構，並於委託合約中明示法規遵循與責任承擔\n' +
                '  - 委託業務：信用卡·帳戶轉帳·簡訊服務 → Settlebank\n\n' +
                '第6條 使用者權利\n' +
                '使用者與法定代理人可透過網站查詢、修改、刪除個人資料，或申請退會\n\n' +
                '第7條 同意撤回\n' +
                '對於會員註冊等所作之同意，可透過書面、電話或電子郵件申請撤回並立即處理\n\n' +
                '第8條 Cookie 運作\n' +
                '為提供個人化服務使用 Cookie，使用者可透過瀏覽器設定允許或拒絕，拒絕時部分服務可能受限\n\n' +
                '第9條 保護措施\n' +
                '  - 密碼保護、防毒程式、加密演算法、入侵防禦系統之應用\n' +
                '  - 僅限負責人員存取並定期實施教育訓練\n\n' +
                '第10條 兒童資料保護\n' +
                '14歲以下必須取得法定代理人同意\n\n' +
                '第11條 廣告訊息發送\n' +
                '未明確表示拒絕不得發送廣告，發送時必須標註「廣告」字樣\n\n' +
                '第12條 負責人聯絡方式\n' +
                '個人資料保護負責人：金學洙（經營支援室）1577-0564 / kimhs@thekgolf.com\n' +
                '第13條 修訂\n' +
                '施行日期：2021年01月02日',

            refundText:
                '本規定適用於於㈜K高爾夫及加盟店中，消費者以預付款方式購買的限定使用期間或次數的內容使用權（例如：月套餐券、次數券、季節券等）要求退款的情況，根據相關法令、公平交易委員會的消費者爭議解決標準及業界標準來運營。\n\n' +
                '第1條（退款事由及標準）\n' +
                '1. 因消費者自身原因要求退款時\n' +
                '  1) 使用開始前：\n' +
                '    - 自付款日起7日內提出退款要求時：依據《電子商務法》第17條及第18條第9款，全額退款，無違約金與手續費。\n' +
                '    - 超過7日後提出退款要求時：撤銷權消失，適用使用開始後的標準。\n' +
                '  2) 使用開始後：\n' +
                '    - 扣除已使用天數/次數對應金額（正常單價）後退還餘額。\n' +
                '    - 餘額中扣除違約金（手續費）10%後退款。\n\n' +
                '2. 因商家責任要求退款時\n' +
                '  1) 使用開始前：全額退款。\n' +
                '  2) 使用開始後：未使用的剩餘期間或次數金額全額退款，無手續費。\n\n' +
                '第2條（退款流程）\n' +
                '1. 書面申請或聯繫客服中心申請。\n' +
                '2. 付款日起7日內要求時，立即全額退款。\n' +
                '3. 使用開始後要求退款時，扣除已使用部分與違約金10%後於7個工作日內退款。\n' +
                '4. 加盟店→總公司轉交後，進行結算與退款處理。\n\n' +
                '第3條（退款計算範例）\n' +
                '例：月套餐券  100$ ・使用期間30日\n' +
                '  - 使用10日後取消\n' +
                '    · 使用金額：10 × 3.3$ = 33$\n' +
                '    · 餘額：100 – 33 = 67$\n' +
                '    · 違約金10%：6.7$ \n' +
                '    · 退款金額：60.3$（約60$）\n\n' +
                '第4條（客服聯繫方式）\n' +
                '退款及諮詢：客服中心 +82-1577-0564\n\n' +
                '第5條（法律依據）\n' +
                '· 《電子商務等消費者保護相關法律》第17條・第18條\n' +
                '· 同法施行令第21條\n' +
                '· 《消費者爭議解決標準》（公平交易委員會公告 第2023-14號）'
        },
        tournament: {
            list: {
                tournamentOpen: '比賽開設',
                tournamentId: '比賽號碼',
                title: '比賽名',
                tournamentType: '開設類型',
                period: '期間',
                participantCount: '參加人員',
                courseCount: '球場數量',
                modify: '修改',
                etc: '其他',
                expires01: '新的錦標賽系統計劃在七月更新。 更新後，玩家每場比賽最多可選擇四個球場。',
                expires02: '對於更新之前安排的比賽，請將結束日期設為不晚於 2024 年 9 月 15 日。',

                modifyPossibility: '可修改',
                modifyImpossibility: '不可修改',
                listDelete: '刪除',
                earlyTermination: '提前結束',
                awarding: '頒獎',
                awardAnnouncement: '發布頒獎',
                awardRecipientsView: '頒獎明細',

                statusFilter: {
                    all: '所有',
                    proceeding: '進行中',
                    expected: '預計',
                    end: '結束',
                },

                popup: {
                    deleteTournamentConfirm: {
                        text1: '請問需要刪除所選比賽嗎？ ',
                        text2: '※刪除比賽將無法復原',

                        requestSuccess: '已經刪除比賽',
                        requestFail: '刪除比賽失敗\n請重新刪除',
                    },
                    earlyEndTournamentConfirm: {
                        text1: '請問基於目前時間結束該比賽嗎？ ',
                        text2: '※ 如果結束比賽，您將無法參加比賽',
                        text3: '但是，目前參與比賽的選手可以比賽',

                        requestSuccess: '比賽提前結束了。 ',
                        requestFail: '提前結束比賽失敗\n請重新結束',
                    },
                },
            },

            open: {
                tournamentTerm: '比賽條款',
                acceptTerms: '條款同意',

                participatingStoresSettingAlert: '只能開10個。 ',
                participatingStoresSetting: '參與店鋪設置',
                addParticipatingStore: '參與店鋪店鋪',
                country: '國家',
                province: '詩/道',
                city: '市/郡/區',
                participatingStore: '參與店鋪',

                basicSetting: '基本設定',
                tournamentTitle: '比賽名',
                tournamentTitlePlaceholder: '請輸入比賽名稱 韓文20字,英文40字以內)',
                tournamentTitleInvalidMessage: '請輸入40字以內比賽名稱',
                tournamentIntroduce: '比賽介紹',
                tournamentIntroducePlaceholder: '請簡單輸入比賽介紹 (韓文100字,英文120字以內)\n※若不輸入將會顯示空白欄。 ',
                tournamentIntroduceInvalidMessage: '請輸入120字以內比賽介紹',
                tournamentSummary: '比賽摘要',
                tournamentParticipantTerms: '參與者使用條款',
                tournamentSummaryDefaultValue:
                'K高爾夫比賽使用條款\n' +
                'K高爾夫比賽是由K高爾夫總部、K高爾夫店主或店主協會代表主辦，利用K高爾夫的程式和設備舉辦的模擬高爾夫比賽。\n' +
                '\n' +
                '第1條: 參賽資格\n' +
                '除非正常會員外，所有正式註冊為K高爾夫會員的用戶均可參加。\n' +
                '非正常會員及非會員可參加比賽，但其所有回合記錄將從排名、統計及獎項中排除。\n' +
                '（非正常會員指因參與不正當活動而受到制裁或處罰的會員，或持有相應違規判定賬號的用戶。）\n' +
                '\n' +
                '第2條: 參賽方式\n' +
                '在全國任意K高爾夫門店登入後，進入比賽模式，從比賽列表中選擇要參加的比賽並完成回合。\n' +
                '除門店的回合費用外，無需支付額外參賽費。\n' +
                '每人僅限使用一個以本人名義註冊的賬號參加。使用他人賬號或多個賬號參賽的情況，將取消所有賬號的參賽資格，並排除在獎項範圍之外。\n' +
                '\n' +
                '第3條: 獎項規則\n' +
                '比賽結束後，可通過K高爾夫App查看最終排名。違反比賽規則者將被取消獲獎資格。\n' +
                '（非會員及店主不參與獎項評選。）\n' +
                '獎項條件由比賽主辦方決定，按通知規定進行頒獎。根據比賽進程，獎項內容可能有所變動。\n' +
                '若會員的聯繫方式（手機號、地址）不正確，主辦方有權取消其獲獎資格。\n' +
                '店主主辦的比賽，K高爾夫總部不對比賽條件及獎項進行干預，也不承擔相關責任。\n' +
                '若出現積分並列的情況，排名將按照完成回合數、倒計分及最後一回合的開始時間順序決定。\n' +
                '如為多場地比賽，倒計分的計算以場地排名中的回合總分進行計算。\n' +
                '\n' +
                '第4條: 比賽規則\n' +
                '登入的情況下，回合結束後分數卡提交及排名將自動完成。\n' +
                '僅認可完成18洞的回合。未完成回合的記錄不計入排名及獎項。\n' +
                '若無法通過攝像頭確認身份，將被視為失格。\n' +
                '回合規則遵循K高爾夫程式，基本條件及中途放棄等由主辦方決定。\n' +
                '因程式問題或自然災害等原因，預先通知的門店比賽可能取消，正在進行的比賽可能中斷。\n' +
                '如因門店狀況（如網路不穩定、停電等）而非服務問題導致的異常，由主辦方與參賽者協商解決。\n' +
                '為解決不可避免的情況，可使用指定數量的補救球（Mulligan）。如無異常情況，也可自行決定是否使用。\n' +
                '可使用個人球杆，主辦方可查看錄像以確認身份，發現違規行為將視為失格。此外，任何電腦操控行為也將導致失格處理。\n' +
                '參賽者必須熟知預先通知的比賽條件，若違反將可能被判定失格。\n' +
                '\n' +
                '第5條: 補充規定\n' +
                '如不服從主辦方指示或未履行相關要求，參賽資格將被限制。\n' +
                '比賽結束後，原則上不接受任何問題或異議。\n' +
                '參賽者因系統故障提出問題時，將通過記錄驗證決定是否受理。\n' +
                '比賽期間保存的視頻將用於獎項審核，且在一定時間後刪除。',
                tournamentThumbnail: '比賽頭像',

                participationTarget: '參加對象',
                participationTargetDescription: '無性別與年齡區分都可以參加',
                addParticipationTarget: '新增參賽物件',
                participationTargetLimitType: '限制區分',
                participationTargetName: '區分名稱',
                participationTargetFullName: '參賽物件區分名',
                participationTargetGender: '性別',
                participationTargetBirthYearLimit: '限出生年度',
                participationTargetType: '參賽物件類型',
                participationTargetMinimumBirthYear: '最小出生年度',
                participationTargetMaximumBirthYear: '最大出生年度',
                participationTargetBirthYearMessage1: '不能選擇開始年度的前面年度',
                participationTargetBirthYearMessage2: '不能選擇結束年度的後面年度',
                participationTargetTeeBoxTypeSetting: '發球位置設定',

                participationGrade: '參加等級',

                participationConditions: '參加條件',
                participationConditionsDescription: '不管原有聊天記錄都可以參加',
                addParticipationConditions: '新增參賽條件',
                participationConditionsLimitType: '限制區分',
                participationConditionsTournamentList: '比賽目錄',
                participationConditionsRankingsLitmit: '排名顯示',
                participationConditionType: '參加條件類型',
                participationConditionsTournamentTitlePlaceholder: '請搜尋比賽',

                participationPeriod: '參賽期間',

                participatePublic: '參與方式',
                participatePublicPlaceholder: '密碼(四位數字)',

                public: '公開',
                nondisclosure: '非公開',

                courseSetting: '球場設置',
                courseCount: '球場數量',
                courseCountUnit: '個',
                courseSelection: '球場選擇',
                courseNumber: 'No',
                courseTitle: '球場名',
                courseType: '球場類型',
                courseDifficulty: '球場難度',
                greenDifficulty: '果嶺難度',
                longestHole: '最遠距離洞',
                nearpinHole: '最進距洞',
                newPerio: '新貝利亞',
                outCourseHole: '前半場',
                inCourseHole: '後半場',

                gameSetting: '比賽設定',
                difficultyEasy: '容易',
                difficultyNormal: '普通',
                difficultyHard: '難',
                difficultyManual: '手動',
                courseStartOrder: '球場開始順序',
                courseStartValue1: '前半場 > 後半場',
                courseStartValue2: '後半場 > 前半場',
                userDifficulty: '玩家難度',
                swingPlate: '動感平台',
                mulliganCount: '摸桿次數',
                windPower: '風速',
                holeCupPosition: '洞杯位置',
                greenPosition: '果嶺位置',
                concede: 'OK球',
                greenSpeed: '果嶺速',
                puttingLineCount: '果嶺線引導次數',
                greenHardness : '果嶺硬度',
                teeBox: '發球位置',
                guideDistance: '目標距離',

                participantHandicap: '參賽者差點',
                calibrationGrade: '分等級校準',
                userGrade: '會員等級',
                scoreCorrection: '成績校準',
                calibrationParticipant: '分參賽物件校準',

                rankingCriteria: '排名計算標準',
                rankingCriteriaDescription1: '排名計算標準設定指的是?',
                rankingCriteriaDescription2: '同位者多人時，決定該同位者的排名順序的標準設定',
                rankingCriteriaOne: '第一',
                rankingCriteriaGameRoundCount: '按比賽記錄多的順序',
                rankingCriteriaGameRoundCountButton: '按比賽記錄多的順序指的是？ ',
                rankingCriteriaGameRoundCountDescription: '當成績相同時，完成 18 洞輪數較多的選手排名靠前。',
                rankingCriteriaTwo: '第二',
                rankingCriteriaOrderByGameRoundDesc: '回溯計算',
                rankingCriteriaCountbackDescription: '按照比賽各球場已登記回合的9洞總和、6洞總和、3洞總和和最後一洞總和的順序進行回溯計算。此回溯計算僅適用於總排名。',
                rankingCriteriaThree: '第三',
                rankingCriteriaBackCount: '使用後半場計分方式',
                rankingCriteriaBackCountButton: '後半場計分方式指的是？ ',
                rankingCriteriaLastRoundStartTime: '最後一輪開始時間',
                rankingCriteriaLastRoundStartTimeDescription: '當成績和比賽記錄相同時，以最後一輪開始時間為準，完成18洞的選手登記為較高的排名。',
                rankingCriteriaUse: '使用',
                rankingCriteriaUnused: '未使用',

                awardSetting: '頒獎設定',
                addAward: '新增頒獎明細',
                awardName: '頒獎名',
                awardNamePlaceholder: '請輸入頒獎名',
                awardGender: '區分性別',
                awardGenderAll: '不區分',
                awardItem: '頒獎項目',
                awardType: '頒獎類型',
                awardCourse: '區分球場',
                awardCourseTotal: '球場綜合',
                awardRankingType: '區分排名',
                awardSingleRanking: '單一排名',
                awardRanegeRanking: '範圍排名',
                awardRankingRange: '排名範圍',
                awardRankingPlaceholder: '請輸入排名',
                awardRankingRangeText1: '從',
                awardRankingRangeText2: '到',
                awardProduct: '頒獎商品',
                awardProductPlaceholder: '請輸入頒獎商品',

                whetherLimit: '限制與否',
                unLimit: '未限制',
                delete: '刪除',
                all: '所有',
                yearUnit: '年',
                yearRangeText1: '從',
                yearRangeText2: '到',

                save: '儲存',
                modify: '修改',

                navigation: {
                    step1: '同意條款',
                    step2: '比賽設定',
                    step3: '比賽開設',
                },

            popup: {
                courseSelection: {
                    title: '選出比賽場地',
                    courseSearch: '球場搜尋',
                    courseSearchPlaceholder: '請搜尋球場',
                    selection: '選擇',
                    save: '儲存',
                    cancel: '關閉',

                    message1: '您不能再選球場了',
                    message2: '請選球場',
                },
                rankingCriteriaGameRoundCount: {
                    text1: '參加開設的比賽，並完成該球場的記錄越多的玩家排名越高的記錄功能',
                    cancel: '關閉',
                },
                rankingCriteriaBackCount: {
                    text1: '玩家成績分為前半場/後半場',
                    text2: '※ 在這裡前半場和後半場指的是先打的9個洞為前半場, 後打的9個洞為後半場',
                    text3: '洞編號為10洞, 也不一定是後半場',
                    text4: '後半(9洞)總成績較好的玩家排名較高',
                    text5: '- 最後打完的洞開始數到9洞',
                    text6: '後半(6洞)總成績較好的玩家排名較高',
                    text7: '- 從最後打完的洞數到6洞',
                    text8: '後半 (3洞) 總成績較好的玩家排名較高。 ',
                    text9: '- 從最後打完的洞開始數到3洞',
                    text10: '比較最後打的洞的成績，成績更好的玩家排名更高。 ',
                    cancel: '關閉',
                },
                shopTournamentOpenConfirm: {
                    text1: '使用填寫的內容開設比賽嗎？ ',
                    text2: '開設的比賽在比賽清單中可以查看及修改。 ',

                    title: '這是已經使用過的比賽名稱。 請輸入其他比賽名稱。 ',

                    requestSuccess: '店鋪比賽開完成',
                    requestFail: '店鋪比賽開課中出現錯誤。 \n請稍後再試。 ',
                },
                shopTournamentModifyConfirm: {
                    text1: '請問按照內容修改比賽嗎？ ',

                    title: '這是已經使用過的比賽名稱。 請輸入其他比賽名稱。 ',

                    requestSuccess: '已經完成店鋪比賽修改',
                    requestFail: '修改店鋪比賽時發生錯誤。 \n請稍後再試',
                },
            },

            alert: {
                message1: '必須輸入至少1個以上參賽對象',
                message2: '差點限-99到99範圍內的值',
                message3: '比賽開始時間基於目前時間過24小時後',
                message4: '比賽時間設定最長1年',
                message5: '球場設定空白，請填寫球場設定',
                message6: '授獎設定內容空白，請填寫授獎設定',
                message7: '把開始順序調小一點',
                message8: '密碼需要輸入4位數字。 ',
                message9: '您設定的排名有錯誤. 請確認.\n範例：無法輸入-1, 0 等數字',
                message10: '請輸入獎項名稱.',
                message11: '請輸入比賽名稱.',
                message12: '新增獎勵詳情請設定獎勵項目。',
                message13: '請檢查課程數量並選擇課程',
            },

            isParticipationGrade: '等級是否使用等級使用與否',
                participationGradeText1:
            '等級使用時<img src="/images/icon/ui_icon_grade_0_0.png" alt="grade" class="icon_grade" /><img src="/images/icon/ui_icon_grade_1_0.png" alt="grade" class ="icon_grade" /> 等級會員不能參加比賽。 ',
                participationGradeSelectTitle: '參加對象',
                participationGradeSelectNoUse: '無限制',
                participationGrade2: 'Bronze',
                participationGrade3: 'Silver',
                participationGrade4: 'Gold',
                participationGrade5: 'Platinum',
                participationGrade6: 'Diamond',
                participationKHandiText6: '-0.1以下（用戶下）',
                participationKHandiText5: '0.0 以上 ~ +7.9 以下（單用戶）',
                participationKHandiText4: '+8.0 以上 ~ +17.9 以下（80 位使用者）',
                participationKHandiText3: '+18.0 以上 ~ 27.9 以下（第 90 位命中者）',
                participationKHandiText2: '+28.0以上~（點擊量100次以上的用戶）',
                participationGradeText6_3: 'Diamond等級全部的 10以下',
                participationGradeText6_2: 'Diamond等級全部的 10%以上~30%以下',
                participationGradeText6_1: 'Diamond等級全部的 30%以上~',
                participationGradeText5_3: '差點 0.0 以上 ~ 2.0 以下',
                participationGradeText5_2: '差點 2.1 以上 ~ 5.0 以下',
                participationGradeText5_1: '差點 5.1 以上 ~ 7.9 以下',
                participationGradeText4_3: '差點 8.0 以上 ~ 10.0 以下',
                participationGradeText4_2: '差點 10.1 以上 ~ 14.0 以下',
                participationGradeText4_1: '差點 14.1 以上 ~ 17.9 以下',
                participationGradeText3_3: '差點 18.0 以上 ~ 20.0 以下',
                participationGradeText3_2: '差點 20.1 以上 ~ 24.0 以下',
                participationGradeText3_1: '差點 24.1 以上~ 27.9 以下',
                participationGradeText2_3: '差點 28.0 以上 ~ 38.0 以下',
                participationGradeText2_2: '差點 38.1 以上 ~ 48.0 以下',
                participationGradeText2_1: '差點 48.1以上~',
                calibration: '修正值',
                kHandi: 'K Handi',
                criteria: '準繩',
                notAllowed: '參加不可',
            },

            details: {
                tab: {
                    summary: '比賽概要',
                    information: '比賽資訊',
                    ranking: '比賽名次',
                    award: '比賽頒獎',
                    awardHistory: '頒獎明細',
                    participantTerms: '參與者使用條款',
                    participatingStoresList: '參與店家目錄',
                },

                information: {
                    introduce: '比賽介紹',

                    tournamentPeriod: '比賽期間',
                    participatePublic:'參與方式',

                    participationTarget: '參賽對象',
                    participationNoLimit: '不限制',
                    participationTargetName: '不區分',
                    participationTargetFullName: '區分參賽物件名稱',
                    participationTargetMinimumBirthYear: '最小出生年度',
                    participationTargetMaximumBirthYear: '最大出生年度',
                    participationTargetTeeBoxSetting: '發球位置設定',

                    participationGrade: '參賽等級',
                    gradeParticipationAvailability: '能否參賽',
                    participationPossible: '可以參賽',
                    unableParticipate: '不可以參賽',

                    participationConditions: '參賽條件',
                    participationConditionTournamentName: '比賽名稱',
                    participationConditionRankingLimit: '排名限制',

                    tournamentCourse: '比賽球場',
                    courseNumber: '球場號',
                    courseName: '球場名稱',
                    courseLongest: '最遠距離',
                    courseNearpin: '最近洞',
                    sinperioExclusionHall: '新貝利亞除外洞',

                    userDifficulty: '選手難度',
                    swingPlate: '動感平台',
                    mulliganCount: '摸桿次數',
                    windPower: '風速',
                    holeCupPosition: '洞杯位置',
                    greenPosition: '果嶺位置',
                    concede: 'OK球',
                    greenSpeed: '果嶺速',
                    puttingLineCount: '果嶺線次數',
                    teeBox: '發球位置',
                    greenHardness: '果嶺硬度',
                    calibrationGrade: '分等級校準',
                    guideDistance: '目標距離',

                    calibrationParticipant: '分參賽物件校準',

                    awardItem: '頒獎項目',
                    awardName: '頒獎名',
                    awardType: '頒獎類型',
                    awardCourse: '球場部分',
                    awardRankingType: '排名區分',
                    awardSingleRanking: '單一排名',
                    awardRanegeRanking: '範圍排名',
                    awardRankingRange: '排名範圍',
                    awardRankingUnit: '等',
                    awardProduct: '頒獎獎',
                    awardNone: '不存在',
                    awardAll: '全部',

                    awardAnnouncement: '授獎者發布',
                    scoreCorrection: '成績校準',
                    genderNoLimit: '無關',
                    participationGradeTitle: '參加物件及補正資訊',
                },

                participatingStoresList: {
                    country: '國家',
                    province: '詩/道',
                    city: '市/郡/區',
                    participatingStore: '參與店鋪',
                    all: '全部',
                },

                ranking: {
                    courseTotalScore: '總成績',
                    searchTextBoxPlaceholder: '請輸入暱稱',

                    allRanking: '所有排名順序',
                    allRankingOption1: '依排名高的順序',
                    allRankingOption2: '依排名低的順序',
                    allRankingOptionReset: '初始化',

                    genderRanking: '性別排名順序',
                    genderRankingOption1: '限女性',
                    genderRankingOption2: '限男性',
                    genderRankingOptionAll: '所有',

                    nickname: '暱稱',
                    participationCount: '參賽次數',
                    teeBoxLocation: '發球檯位置',
                    totalDistance: '飛行距離 (m)',
                    remainDistance: '剩餘距離 (m)',
                    recordTime: '達成時間',
                    lastRoundStartTime: '最後一輪開始時間',
                    newPerioScoreRecord: '12洞成績',
                    finalScore: '最終成績',
                    birdieCount: '柏忌數',
                    eagleCount: '老鷹數',
                    courseName: '球場名字',
                    holeNumber: '洞號',
                    courseDistance: '總長距離',
                    totalParticipationCount: '總參賽次數',
                    gradeRankingOption1: '高序',
                    gradeRankingOption2: '低序',
                    handicap: '差點',
                },

                awardRanking: {
                    allChoice: '全選',
                    awardConfirmation: '頒獎確定',
                    resetAwards: '頒獎初始化',
                    awardRecipientsSelection: '授獎者選定',

                    courseScore: '球場成績',
                    handicap: '差點',
                    additionalHandicap: '追加差點',
                    adjustmentResult: '調整結果',
                    adjustmentSynthesis: '調整綜合',
                    finalScore: '最終成績',
                    courseOverall: '球場綜合',
                    swingVideo: '揮桿影像',
                    videoPlay: '影像回放',

                    alert: {
                        message1: '差點限-99到99範圍內的值',
                    },
                },

                awardHistory: {
                    rankingUnit: '第',

                    ranking: '排名',
                    nickname: '暱稱',
                    record: '記錄',
                    recordTime: '達成時間',
                    totalParticipationCount: '總參賽次數',
                    courseName: '球場名稱',
                    holeNumber: '洞號',
                },

                course: '課程',
                summation: '求和',
                gender: '性別',
                grade: '參加時等級',
                startGrade: '起始年級',
                lastGrade: '最終年級',
                handicapGrade: '年級',
                storeUse: '利用店家',
                public: '公開',
                nondisclosure: '非公開',

                alert: {
                    message1: '比賽結束後需過24小時',
                    message2: '選定比賽授獎者後可查看授獎內容',
                },

                popup: {
                    resetTournamentAwardsConfirm: {
                        text1: '請問確定授獎初始化嗎？ ',
                        text2: '假如確定授獎初始化，目前登記的追加差點及授獎確定內容將會全部初始化',

                        requestSuccess: '授獎明細全部初始化',
                        requestFail: '授獎內容初始化失敗。 \n請重新操作',
                    },

                    tournamentAwardRecipientsSelectionConfirm: {
                        text1: '基於目前登記的授獎確定，選定授獎者嗎？ ',
                        text2: '登記的內容可在授獎明細頁確認',
                        text3: '一旦獲獎者公佈，排名將無法更改。',
                        text4: '要修改排名，您必須在進行任何調整之前「初始化獎勵」。',

                        requestSuccess: '已完成選定授獎者。 \n請授獎明細頁確認',
                        requestFail: '授獎者選定失敗。 \n請重新操作',
                    },

                    tournamentAwardAnnouncementConfirm: {
                        text1: '一旦發布授獎者，就無法修改授獎者',
                        text2: '請問您要發佈授獎者嗎？ ',

                        requestSuccess: '已完成授獎者發布',
                        requestFail: '授獎者發布失敗',
                    },
                },
            },

            awardItem: {
                Score: '成績',
                Longest: '最遠',
                Nearpin: '最近洞',
                HoleInOne: '一桿進洞',
                CourseRoundPlayCount: '下場次數',
            },
            awardType: {
                Stroke: '比桿',
                NewPerio: '新貝利亞',
                BirdieCount: '柏忌數',
                EagleCount: '老鷹數',
            },
        },
        control: {
            image: {
                delete: '刪除',
                fileSelect: '選擇檔案',
            },
        },
        contentsItem: {
            info: {
                prevItem: '以前的購買資訊',
                prevItemText: '這是無法再購買的內容通行證。 <br/>如需購買，請聯絡服務營運團隊。 ',
                itemText: '該產品在購買後自動套用。 ',
                alertMsgTitle: '內容使用資訊',
                alertMsgSubTitle: '正在使用的票證資訊',
                alertMsgUser: '你好。 {user}先生。 ',
                paymentMsg: '購買的內容產品已如下應用。 ',
                paymentTitle: '選擇付款方式',
            },
            button: {
                payment: '去買',
                purchase: '買',
                rePurchase: '再購買',
                creditCard: '信用卡',
                cash: '現金支付',
                paypal: 'PayPal',
            },
            shopSupplyItem: {
                salesCode:'材料代碼'
              },
            1010110110: {
                title: '內容票（期限）',
                icon: '/itemImage/ui_icon_period.png',
                unit: 'DAYS',
                itemInfo: '店舖機器',
                itemDescription: '這是內容使用通行證（有期限），允許您使用遊戲內容 {count} 天。 ',
                itemPayment: '已新增 {count} 天，因此您可以使用該內容 {newCount} 天。 ',
                alertMsg: '店鋪中使用的所有內容使用通行證（期限）將在 {count} 天後用完。 為了順利使用內容，請購買內容使用權（期限）。 ',
                alertMsgNone: '店內使用的所有內容（限期）已售完。 \n如果您沒有內容許可證（有期限），則無法玩新遊戲。 \n請前往店舖購買內容訂閱（期間）。 ',
            },
            1010120110: {
                title: '內容票（洞）',
                icon: '/itemImage/ui_icon_round.png',
                unit: 'HOLE',
                itemDescription: '這是一張內容憑證（洞），可讓您使用多達 {count} 個洞的遊戲內容。 ',
                itemPayment: '增加了 {count} 個洞後，內容就可以使用 {newCount} 個洞了。 ',
                alertMsg: '店舖中尚有 {count} 個內容通行證（洞）仍在使用。 為了順利使用內容，請購買內容使用券（大廳）。 ',
                alertMsgNone: '店舖中尚有 {count} 個內容通行證（洞）仍在使用。 如果內容票（洞）少於 {round} 洞，您將無法玩新遊戲。 請前往店舖購買內容通行證（洞）。 ',
            },
            alertMsg: {
                all: '店內使用的{day}天內容使用券（限期）和內容使用券（洞）將在打完{count}洞後耗盡，因此請購買內容使用券（限期）或內容使用券（ 洞） ）以順利使用內容。 ',
                allNone: '在店舖中使用的內容使用券（期限）已變為{day}天，並且正在使用的內容使用券（洞）已變為{round}洞以下。 \n如果您沒有足夠的內容，您將無法玩新遊戲。 \n請前往店鋪並購買內容存取權限。 ',
            },
            // 소모품 구매
            51101511111011: {
                title: 'Mat BGS Type Stance Mat',
                icon: '/itemImage/KGFMAT001012.jpg',
                unit: 'ea',
                itemDescription: '包含橡膠底座的站立墊，尺寸 1100x1300 mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100061',
            },
            51101511111012: {
                title: 'Mat BGS Type (Left/Right) Fairway Mat Set',
                icon: '/itemImage/KGFMAT001013.jpg',
                unit: 'set',
                itemDescription: '一體成型墊子套裝，附球道、長草區、沙坑和橡膠底座，600x1300 毫米。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100062',
            },
            51101511111013: {
                title: 'Mat BGS Type Cut-Out Fairway Mat',
                icon: '/itemImage/KGFMAT002015.jpg',
                unit: 'ea',
                itemDescription: '球道墊，有長草區和沙坑開口，底部有魔鬼氈，尺寸：600x1300mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100081',
            },
            51101511111014: {
                title: 'Mat BGS Type Fairway Mat',
                icon: '/itemImage/KGFMAT002016.jpg',
                unit: 'ea',
                itemDescription: '球道墊，有頂面和雙色草皮，尺寸：370x1300mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100082',
            },
            51101511111015: {
                title: 'Mat BGS Type Rubber base',
                icon: '/itemImage/700004.jpg',
                unit: 'ea',
                itemDescription: '橡膠底，有沙坑和長草區開口，尺寸：600x1300mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100073',
            },
            51101511111016: {
                title: 'Mat BGS Type Rough Mat',
                icon: '/itemImage/KGFMAT002001.jpg',
                unit: 'ea',
                itemDescription: '長草墊，底部有魔鬼氈，尺寸：400x230mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100067',
            },
            51101511111017: {
                title: 'Mat BGS Type Grey Bunker Mat',
                icon: '/itemImage/KGFMAT002017.jpg',
                unit: 'ea',
                itemDescription: '灰色沙坑墊，底部有魔鬼氈，尺寸：400x230mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100083',
            },
            51101511111018: {
                title: 'Mat BGS Type Silver Brush Bunker Mat',
                icon: '/itemImage/KGFMAT001011.jpg',
                unit: 'ea',
                itemDescription: '銀色刷狀沙坑墊，鋼底帶魔鬼氈，尺寸：400x230mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100060',
            },
            51101512111011: {
                title: 'Mat KDR Type Stance Mat',
                icon: '/itemImage/KGFMAT001015.jpg',
                unit: 'ea',
                itemDescription: '站姿墊，附橡膠底，尺寸：1000 x 1000mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100064',
            },
            51101512111012: {
                title: 'Mat KDR Type Fairway Mat',
                icon: '/itemImage/KGFMAT001017.jpg',
                unit: 'ea',
                itemDescription: '球道墊，帶橡膠底和雙色草皮，尺寸：500x1000mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100066',
            },
            51101513111011: {
                title: 'Auto Tee Type  Auto Tee up System',
                icon: '/itemImage/100175.jpg',
                unit: 'ea',
                itemDescription: '內建自動發球系統套裝，含整合式地板按鍵。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100175',
            },
            51101514111012: {
                title: 'Consumables Type Rubber Tee',
                icon: '/itemImage/100187.jpg',
                unit: 'ea',
                itemDescription: '橡膠球座 (JE)<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100187',
            },
            51101514111013: {
                title: 'Consumables Type Rubber Tee (Moving Swing Plate)',
                icon: '/itemImage/100188.jpg',
                unit: 'ea',
                itemDescription: '適用於揮桿板的橡膠球座，相容於 JE 自動上桿系統。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100188',
            },
            51101517700001: {
                title: 'Mat BGS Type Fairway Mat',
                icon: '/itemImage/700001.jpg',
                unit: 'ea',
                itemDescription: '球道垫采用双色草皮，底部为魔术贴，尺寸为 370x1040mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '700001',
            },
            51101517700002: {
                title: 'Mat BGS Type Fairway Extension Mat 1',
                icon: '/itemImage/700002.jpg',
                unit: 'ea',
                itemDescription: '球道墊延長板，魔鬼氈底部，尺寸 230x240mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '700002',
            },
            51101517700003: {
                title: 'Mat BGS Type Fairway Extension Mat 2',
                icon: '/itemImage/700003.jpg',
                unit: 'ea',
                itemDescription: '球道墊延長板，魔鬼氈底部，尺寸 260x600mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '700003',
            },
            51101517700004: {
                title: 'Mat BGS Type Fairway Mat Rubber base',
                icon: '/itemImage/700004.jpg',
                unit: 'ea',
                itemDescription: '球道套裝橡膠底，魔鬼氈頂部，尺寸 600x1300mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '700004',
            },
            51101517700005: {
                title: 'Mat BGS Type Rough Mat',
                icon: '/itemImage/700005.jpg',
                unit: 'ea',
                itemDescription: '長草區球道墊，魔鬼氈底部，尺寸 400x230mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '700005',
            },
            51101517700007: {
                title: 'Mat BGS Type Stance Mat',
                icon: '/itemImage/700007.jpg',
                unit: 'ea',
                itemDescription: '站姿墊，橡膠底，尺寸 1100x1300mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '700007',
            },
            51101517700009: {
                title: 'Mat BGS Type Fairway Set (Right Hand)',
                icon: '/itemImage/700009.jpg',
                unit: 'ea',
                itemDescription: '右手一體成型球道墊套裝，包含球道、長草區、沙坑和橡膠底，尺寸 600x1300mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '700009',
            },
            51101517700010: {
                title: 'Mat BGS Type Fairway Set (Left Hand)',
                icon: '/itemImage/700010.jpg',
                unit: 'ea',
                itemDescription: '左手一體成型球道墊套裝，包含球道、長草區、沙坑和橡膠底，尺寸 600x1300mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '700010',
            },
            51101517100175: {
                title: 'Auto Tee Type Auto Tee up System(Right Hand)',
                icon: '/itemImage/100175.jpg',
                unit: 'ea',
                itemDescription: '右手專用內建自動發球系統套裝，含整合式地面按鍵。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100175',
            },
            51101517100176: {
                title: 'Auto Tee Type Auto Tee up System (Left Hand)',
                icon: '/itemImage/100176.jpg',
                unit: 'ea',
                itemDescription: '左手專用內建自動發球系統套裝，含整合式地面按鍵。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100176',
            },
            51101517100222: {
                title: 'Mat BGS Type Bunker Mat',
                icon: '/itemImage/100222.jpg',
                unit: 'ea',
                itemDescription: '鋼製底面刷毛沙坑墊，附魔鬼氈，尺寸 400x230 mm。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100222',
            },
            51101514111011: {
                title: 'Consumables Type Rubber Tee',
                icon: '/itemImage/100186.jpg',
                unit: 'ea',
                itemDescription: '橡膠球座（CT&G）<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100186',
            },
            51101514111014: {
                title: 'Consumables Type Marking Golf Balls',
                icon: '/itemImage/KGFBAL001001.jpg',
                unit: 'box',
                itemDescription: '標示4點圖案，每盒300個球。<br />* 您可以在付款管理選單中查看訂單狀態。',
                salesCode: '100166',
            },       
        },
    },
};
